import powerbod from "../assets/powerbod.png"

export default powerbod